import { useMsal } from "@azure/msal-react";
import { useCallback } from "react";

export function useAuthToken(): () => Promise<string> {
  const { instance, accounts } = useMsal();

  // account is computed inside useCallback so it doesn't appear in the dep array.
  // An inline `accounts[0]` object changes reference every render, which would make
  // this callback a new function every render → infinite re-fetch loop downstream.
  return useCallback(async () => {
    const account = accounts[0] || instance.getActiveAccount();
    if (!account) {
      if (process.env.REACT_APP_AUTH_DISABLED === "true") return "";
      throw new Error("not signed in (no Entra account)");
    }
    const res = await instance.acquireTokenSilent({
      scopes: ["openid", "profile", "email"],
      account,
    });
    // ID token (not access token): aud=clientId, validatable from tenant JWKS,
    // contains email/profile claims. Graph access tokens are not verifiable by
    // third-party APIs — their signatures intentionally fail external validation.
    return res.idToken;
  }, [instance, accounts]);
}
